<script>
import { mapStores } from "pinia";
import { defineComponent } from "vue";

import ArticleContent from "@/components/article/ArticleContent.vue";
import ArticleContentCollapser from "@/components/article/ArticleContentCollapser.vue";
import lang from "@/directives/lang";
import { useSearchStore } from "@/stores";

import ArticleContentHeader from "./ArticleContentHeader.vue";
import ArticleContentTranslation from "./ArticleContentTranslation.vue";

export default defineComponent({
  name: "ChildrensDanishEnglishArticleContent",
  components: {
    ArticleContent,
    ArticleContentCollapser,
    ArticleContentHeader,
    ArticleContentTranslation
  },
  directives: {
    lang
  },
  props: {
    article: {
      type: Object,
      required: true
    },
    hasReadingLines: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true
    },
    isCollapsible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapStores(useSearchStore),

    searchDirection() {
      return this.searchStore.searchDirection;
    },

    illustration() {
      const urlPrefix = "https://static.ordbogen.com/politiken/feo/images/";
      const article = this.article;

      const word = article.word;
      if (word.illustration) {
        return {
          url: urlPrefix + word.illustration,
          text: word.imageText
        };
      }

      const meaning = article.meanings.find(
        (meaning) => meaning.illustration !== undefined && meaning.illustration !== ""
      );
      if (meaning) {
        return {
          url: urlPrefix + meaning.illustration,
          text: meaning.imageText
        };
      }

      return null;
    }
  }
});
</script>

<template>
  <ArticleContent>
    <ArticleContentHeader :word="article.word" :direction="searchDirection" />

    <ArticleContentCollapser :is-collapsible="isCollapsible">
      <div
        class="article-content__body-container d-flex flex-column flex-lg-row"
        :class="{ 'article-content__body-container--reading-lines': hasReadingLines }"
      >
        <div class="indentation-container flex-grow-1 flex-shrink-1">
          <div class="indentation-container">
            <div v-for="(meaning, index) in article.meanings" :key="index">
              <ArticleContentTranslation :translation="meaning" :direction="searchDirection" />
            </div>
            <div class="article-content__spacer"></div>
          </div>
        </div>
        <div
          v-if="illustration"
          class="article-content__image-container d-flex align-items-start justify-content-center"
        >
          <img
            class="article-content__image img-fluid"
            :src="illustration.url"
            :alt="$t('article.illustration.alt', { word: illustration.text })"
          />
        </div>
      </div>
    </ArticleContentCollapser>
  </ArticleContent>
</template>
